export default class TabMapManager extends Map {
  constructor(maxLength = 10) {
    super();
    this.maxLength = maxLength;
  }

  delete(key) {
    super.delete(key);
  }

  deleteOther(key) {
    const keys = Array.from(this.keys());
    for (const item of keys) {
      if (item !== key) {
        this.delete(item);
      }
    }
  }

  set(key, value) {
    super.set(key, value);
    if (this.size > this.maxLength) {
      const firstKey = Array.from(this.keys())[0];
      this.delete(firstKey);
    }
  }

  getTabs() {
    return Array.from(this);
  }

  indexOf(key) {
    const keys = this.keys();
    let item = null;
    let index = -1;
    while ((item = keys.next())) {
      index++;
      if (item.value === key) {
        break;
      }
    }
    return index;
  }

  getPrev(key) {
    const index = this.indexOf(key);
    if (index <= 0) {
      return null;
    }
    const k = Array.from(this.keys())[index - 1];
    return this.get(k);
  }

  getNext(key) {
    const index = this.indexOf(key);
    const keys = Array.from(this.keys());
    if (index >= keys.length - 1) {
      return null;
    }
    const k = keys[index + 1];
    return this.get(k);
  }
}
